import { render, staticRenderFns } from "./EnterTerminalID.vue?vue&type=template&id=13cb5ce6&"
import script from "./EnterTerminalID.vue?vue&type=script&lang=js&"
export * from "./EnterTerminalID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports